import { dataViewFormatter } from '@app/widgets/helpers/widgets';
import { EChartsOption } from 'echarts';

const BasicScatterChartColourPalette = ['#6AB6B0', '#2A5FA5', '#52844B'];

const BasicScatterChartEchartConfigTemplate: EChartsOption = {
  color: BasicScatterChartColourPalette,
  legend: {},
  tooltip: {
    confine: true,
    trigger: 'axis',
    position: function (pt: any) {
      return [pt[0], '10%'];
    },
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985',
      },
    },
    textStyle: {
      color: '#fff',
    },
  },
  toolbox: {
    feature: {
      dataView: {
        show: true,
        readOnly: false,
        optionToContent: (option: any): string | HTMLElement => dataViewFormatter(option as EChartsOption),
      },
      saveAsImage: { show: true },
    },
  },
  grid: {
    top: '25%',
    left: '3%',
    right: '10%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    type: 'value',
    name: 'PLACEHOLDER',
    offset: 0,
    alignTicks: true,
    axisLine: {
      show: true,
    },
  },
  yAxis: {
    type: 'value',
    name: 'PLACEHOLDER',
    offset: 0,
    alignTicks: true,
    axisLine: {
      show: true,
    },
  },
  series: [
    {
      type: 'scatter',
      symbolSize: 10,
    },
  ],
};

export { BasicScatterChartEchartConfigTemplate, BasicScatterChartColourPalette };
